function splitString(inputString, separator) {
  const separatorIndex = inputString.indexOf(separator);
  const firstPart = separatorIndex !== -1 ? inputString.slice(0, separatorIndex) : inputString;
  const secondPart = separatorIndex !== -1 ? inputString.slice(separatorIndex + 1) : '';

  return [firstPart, secondPart];
}

function parseCodeString(inputString = '', options = {}) {
  if (typeof inputString !== 'string') return null;

  if (typeof options !== 'object' || options === null) {
    throw new Error('Options must be an object.');
  }

  const { codeSeparator = ';', attributesSeparator = ';', keyValueSeparator = ':' } = options;

  const [code, attributesString] = splitString(inputString, codeSeparator);

  let attributes = [];
  if (attributesString) {
    const attributePairs = attributesString.split(attributesSeparator);
    attributes = attributePairs
      .map((pair) => {
        const [key, value] = splitString(pair, keyValueSeparator);
        return { key, value };
      })
      .filter((pair) => pair.value != null && pair.value !== '');
  }

  return { code, attributes };
}

export { parseCodeString };
export default parseCodeString;
